/*
 * Copyright (c) 2018 - Indigen Solutions
 * Authors:
 *   - Bichoy Messiha <bm@indigen.com>
 * NOTICE: All information contained here in is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Indigen Solutions.
 */
import { createAction } from ".";
import { NotificationItem } from "../../types/NotificationItem";

export const NOTIFICATION_SET_ACTION = "notification.set";

export const setNotification = createAction<NotificationItem>(NOTIFICATION_SET_ACTION);



// WEBPACK FOOTER //
// ./src/store/actions/notification.actions.ts